<template>
  <v-row justify="center">
    <v-dialog v-model="visible" persistent max-width="600px">
      <v-form ref="form" @submit.prevent="handleSubmit">
      <v-card v-if="user" :loading="loading">
        <v-card-title>
          <span class="headline">{{$t('modal.editUser.title')}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-alert
                  v-if="error"
                  border="left"
                  colored-border
                  type="error"
                  elevation="2"
                >
                  {{error}}
                </v-alert>
              </v-col>
                
              <!-- name -->
              <v-col cols="6">
                <v-text-field :label="$t('label.name')" v-model="user.name" :rules="[rules.required]"/>
              </v-col>

              <!-- title -->
              <v-col cols="6">
                <v-text-field :label="$t('label.title')" v-model="user.title" />
              </v-col>

              <!-- phone -->
              <v-col cols="6">
                <v-text-field :label="$t('label.phone')" v-model="user.phone" />
              </v-col>

              <!-- location -->
              <v-col cols="6">
                <v-text-field :label="$t('label.location')" v-model="user.location" />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="onCancel">{{$t('label.cancel')}}</v-btn>
          <v-btn color="blue darken-1" type="submit">{{$t('label.save')}}</v-btn>
        </v-card-actions>
      </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>

<script>

export default {
  name: "EditProfile",
    data() {
    return {
      rules: {
        required: value => !!value || 'Required.'
      }
    };
  },
  props: {
    error: {},
    user: {},
    loading: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleSubmit() {
      if(!this.$refs.form.validate()){
        return false
      }
      this.$emit("onConfirmed", this.user);
    },
    onCancel() {
      this.$emit("onCancelled");
    }
  },
  created: function() {}
};
</script>